import { render } from "./RoomSelector.vue?vue&type=template&id=fb9b00b6&scoped=true"
import script from "./RoomSelector.vue?vue&type=script&lang=js"
export * from "./RoomSelector.vue?vue&type=script&lang=js"

import "./RoomSelector.vue?vue&type=style&index=0&id=fb9b00b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9b00b6"]])

export default __exports__